import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';

Calendar[$.FILENAME] = 'src/web/concepts/calendar.svelte';

import * as $ from 'svelte/internal/client';
import Booking from "./booking.svelte";

var root = $.add_locations(
	$.from_html(
		`

<div class="w-full max-w-2xl flex flex-col gap-8">
  <h1 class="font-display text-4xl md:text-6xl font-semibold tracking-tight">Pick a time.<br/>We'll take it from there.</h1>
  <p class="text-lg opacity-60">30 minutes on video. You explain how your company works, we tell you what we'd build.</p>
  <!>
</div>`,
		1
	),
	Calendar[$.FILENAME],
	[[5, 0, [[6, 2, [[6, 89]]], [7, 2]]]]
);

function Calendar($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, false, Calendar);

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root();
	var div = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(div), 5);

	$.add_svelte_meta(() => Booking(node, {}), 'component', Calendar, 8, 2, { componentTag: 'Booking' });
	$.next();
	$.reset(div);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Calendar = $.hmr(Calendar);

	import.meta.hot.accept((module) => {
		Calendar[$.HMR].update(module.default);
	});
}

export default Calendar;